import { RiArrowUpDownLine } from 'react-icons/ri'
import { FaArrowUp, FaArrowDown } from 'react-icons/fa'

const HeaderSpan = ({
  headerTitle,
  background,
  columnType,
  sortType,
  sortOrder,
  w,
  handleOnClick,
}) => {
  return (
    <div onClick={() => handleOnClick(columnType)} style={{ width: w + '%' }}>
      <div className={'level pt-1 pb-1 ' + background}>
        <div className="level-left">
          <div className="level-item">
            <span className="pl-2 has-text-info-dark">{headerTitle + ' '}</span>
          </div>
        </div>

        <div className="level-center">
          <div className="level-item"></div>
        </div>

        <div className="level-right">
          <div className="level-item pr-1">
            {columnType !== '' ? (
              sortType !== columnType ? (
                <RiArrowUpDownLine className="has-text-grey-light" />
              ) : sortOrder === false ? (
                <FaArrowUp className="has-text-link" />
              ) : (
                <FaArrowDown className="has-text-link" />
              )
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeaderSpan
